import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router';

import {
  ILocumUserData,
  LocumSignInDataType,
} from '../../models/auth/signIn.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import useHttps from '../useHttps';
import { INVITED_JOBS } from '../../routes/routeConstants';

const useUserSignin = () => {
  const navigate = useNavigate();
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDisPatch();

  // 1. Read the raw string
  const raw = sessionStorage.getItem('invt');

  // 2. Parse it (with a fallback in case it’s missing)
  const inviteData: { state: boolean; jobId: string } = raw
    ? JSON.parse(raw)
    : { state: false, jobId: '' };

  const setAuthentication = ({ data }: SuccessHttpResponse<ILocumUserData>) => {
    dispatch(
      authActions.setAuthentication({ authData: data, isAuthenticated: true })
    );
    localStorage.setItem('authData', JSON.stringify(data));
    if (inviteData.state) {
      navigate(`/${INVITED_JOBS}?jobId=${inviteData.jobId}`, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
    // Set a flag so the DashboardHome can trigger post sign‑in action
    sessionStorage.setItem('postSignInAction', 'true');
    sessionStorage.setItem('SIFP', 'true');
    sessionStorage.setItem('SMFP', 'true');
  };

  const onSignInError = (err: AxiosError<ErrorHttpResponse>) => {
    console.log('onLoginError');
    toast.error(err?.response?.data?.message ?? 'Something went wrong');
  };

  const signinUser = (data: LocumSignInDataType) => {
    const url: HttpConfig = {
      url: 'auth-service/users/signin',
      method: 'post',
      data,
    };

    request(url, setAuthentication, setLoading, onSignInError);
  };

  return {
    loading,
    signinUser,
  };
};

export default useUserSignin;
